export { ParticipantRole as DocumentRoleNames } from '../entity'
